import { makeAutoObservable } from 'mobx';
import {successAlert} from 'shared/tools';
import {DomainStore} from 'shared/store';
import {t} from 'shared/core';
import {types, endpoints} from 'main/tools';

class EmployeesContainerState {
  store = new DomainStore();
  interactiveAgent;

  editingEmployee;
  removeEmployeeModalOpen = false;
  addEmployeeModalOpen = false;
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false,
      interactiveAgent: false
    });
  }

  setInteractiveAgent(agent) {
    this.interactiveAgent = agent;
  }

  openRemoveEmployeeModal(employee) {
    this.editingEmployee = employee;
    this.removeEmployeeModalOpen = true;
  }

  closeRemoveEmployeeModal() {
    this.editingEmployee = null;
    this.removeEmployeeModalOpen = false;
  }

  openAddEmployeeModal(employee) {
    this.editingEmployee = employee;
    this.addEmployeeModalOpen = true;
  }

  closeAddEmployeeModal() {
    this.editingEmployee = null;
    this.addEmployeeModalOpen = false;
  }

  async toggleEmployeePayroll(payrollEnabled) {
    const employee = {...this.editingEmployee, payrollEnabled, updateCompensation: payrollEnabled};
    const {model, errors} = await this.store.patch(
      `${endpoints.EMPLOYEES.ALL}/${this.editingEmployee.id}`,
      types.EMPLOYEE_DETAILS,
      employee,
    );

    this.errors = errors;
    if (model) {
      this.editingEmployee.update(model);

      if (payrollEnabled) {
        successAlert(t('payroll.employees.ADDED_TO_PAYROLL', {employeeName: this.editingEmployee.name}));
        this.addEmployeeModalOpen = false;
      } else {
        successAlert(t('payroll.employees.REMOVED_FROM_PAYROLL', {employeeName: this.editingEmployee.name}));
        this.removeEmployeeModalOpen = false;
      }

      this.interactiveAgent.refresh();
    }
  }

  customLinksFor(employee) {
    if (employee.payrollEnabled) {
      return [
        {
          text: 'payroll.employees.Remove',
          action: employee => this.openRemoveEmployeeModal(employee)
        }
      ];
    } else {
      return [
        {
          text: 'payroll.employees.Add to Payroll',
          action: employee => this.openAddEmployeeModal(employee)
        }
      ];
    }
  }
}

export default EmployeesContainerState;
